"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ENearWalletImportType = exports.ENearWalletType = exports.EGetKeysPermissionType = exports.ENearAccessKeyPermission = exports.ENearTokenWrapId = exports.ENearNetwork = void 0;
var ENearNetwork;
(function (ENearNetwork) {
  ENearNetwork["localnet"] = "localnet";
  ENearNetwork["testnet"] = "testnet";
  ENearNetwork["betanet"] = "betanet";
  ENearNetwork["mainnet"] = "mainnet";
})(ENearNetwork = exports.ENearNetwork || (exports.ENearNetwork = {}));
var ENearTokenWrapId;
(function (ENearTokenWrapId) {
  ENearTokenWrapId["WRAP_TESTNET"] = "wrap.testnet";
  ENearTokenWrapId["WRAP_MAINNET"] = "wrap.mainnet";
})(ENearTokenWrapId = exports.ENearTokenWrapId || (exports.ENearTokenWrapId = {}));
var ENearAccessKeyPermission;
(function (ENearAccessKeyPermission) {
  ENearAccessKeyPermission["FULL_ACCESS"] = "FULL_ACCESS";
  ENearAccessKeyPermission["FUNCTION_CALL"] = "FUNCTION_CALL";
})(ENearAccessKeyPermission = exports.ENearAccessKeyPermission || (exports.ENearAccessKeyPermission = {}));
var EGetKeysPermissionType;
(function (EGetKeysPermissionType) {
  EGetKeysPermissionType["ALL"] = "ALL";
  EGetKeysPermissionType["FULL_ACCESS"] = "FULL_ACCESS";
  EGetKeysPermissionType["FUNCTION_CALL"] = "FUNCTION_CALL";
})(EGetKeysPermissionType = exports.EGetKeysPermissionType || (exports.EGetKeysPermissionType = {}));
var ENearWalletType;
(function (ENearWalletType) {
  ENearWalletType["IMPLICIT"] = "IMPLICIT";
  ENearWalletType["NAMED"] = "NAMED";
})(ENearWalletType = exports.ENearWalletType || (exports.ENearWalletType = {}));
var ENearWalletImportType;
(function (ENearWalletImportType) {
  ENearWalletImportType["SEED_PHRASE"] = "SEED_PHRASE";
})(ENearWalletImportType = exports.ENearWalletImportType || (exports.ENearWalletImportType = {}));